const initialState = {}

const updatedPlayerReservations = (playerReservations, pr) => {
  const index = playerReservations.findIndex(e => e.id == pr.id)
  return [
    ...playerReservations.slice(0, index), 
    pr,
    ...playerReservations.slice(index + 1, playerReservations.length)
  ]
}

const appendedPlayerReservations = (playerReservations, pr) => {
  return [ ...playerReservations, pr ]
}

const facilityOpenGameModal = (state = initialState, {type, payload}) => {
  switch (type) {
    case 'FACILITY_OPEN_GAME_MODAL.INIT':
      return {...state, gameId: payload.id, socketUrl: payload.socketUrl, alert: null, payment: null}
    case 'FACILITY_OPEN_GAME_MODAL.CLEAR_GAME':
      return initialState
    case 'FACILITY_OPEN_GAME_MODAL.CLEAR_ALERT':
      if (_.isEmpty(state)) return state

      return {...state, alert: null}
    case 'FACILITY_OPEN_GAME_MODAL.GAME_LOADED':
      return {...state, ...payload}
    case 'FACILITY_OPEN_GAME_MODAL.PR_UPDATED':
      return {...state, player_reservations: updatedPlayerReservations(state.player_reservations, payload)}
    case 'FACILITY_OPEN_GAME_MODAL.START_PAYMENT':
      return {...state, payment: payload}
    case 'FACILITY_OPEN_GAME_MODAL.CLEAR_PAYMENT':
      return {...state, payment: null}
    case 'FACILITY_OPEN_GAME_MODAL.UPDATE_GAME':
      return {...state, game: payload.game, alert: { 'text': 'Game update success', 'type': 'success' } }
    case 'FACILITY_OPEN_GAME_MODAL.GAME_UPDATED':
      return {
        ...state, 
        player_reservations: appendedPlayerReservations(state.player_reservations, payload.player_reservation)
      }
    case 'PAYMENT_SUCCESS':
      if (_.isEmpty(state)) return state

      return {
        ...state,
        game: payload.game,
        player_reservations: updatedPlayerReservations(state.player_reservations, payload.player_reservation),
        payment: null,
        alert: { text: payload.message, type: 'success' }
      }
    }
  return state
}

export default facilityOpenGameModal
